import { useTranslation, Trans } from 'next-i18next'

import { CATEGORY_COLORS } from '~/bootcamp/constants/bootcamp.const'

import ArrowButton from '~/checklist/components/ArrowButton'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { TopicId, getTaskBgGradient } from '~/dashboard/utils/learningPath.utils'

interface Props {
  description: string
  topicId: TopicId
  code?: number
  id: string
  isExpanded: boolean
  isCompleted: boolean
  onClick: () => void
  masteryTrackApplicable: boolean
}
export default function CompetencyDescription({
  description,
  topicId,
  id,
  isExpanded,
  isCompleted,
  code,
  onClick,
  masteryTrackApplicable,
}: Props): React.ReactElement {
  const { t } = useTranslation('curriculum')
  const topicGradient = getTaskBgGradient(topicId)
  const textColor = CATEGORY_COLORS[topicId]?.textClass
  const borderClass = CATEGORY_COLORS[topicId]?.borderClass

  return (
    <div
      className={`relative rounded ${isCompleted ? 'bg-white' : `${topicGradient}`} cursor-pointer ${
        code ? 'mt-5 md:mt-2' : ''
      }`}
      id={id}
      onClick={onClick}
    >
      {isCompleted && (
        // This png is animated and aws brakes it, so that is why it is useing the cloudfront url
        <img
          className="absolute z-5 -top-8 -left-5"
          height={60}
          src="https://assets.houseofmath.com/icons/emojis/clapping-hands-animated.png"
          width={60}
        />
      )}
      {code && (
        <div className="absolute z-5 top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded px-2">
          <p className={`leading-10 text-h3 bg-clip-text font-semibold text-transparent ${topicGradient}`}>
            {Trans({
              t,
              i18nKey: 'goal',
              values: { code },
              children: t('goal'),
            })}
          </p>
        </div>
      )}

      <div
        className={`rounded mx-auto relative w-80 min-h-25 text-center border-2 font-medium leading-7 px-2.5 bottom-2 z-1 ${
          isCompleted ? 'bg-purple-darker border-white' : `bg-white ${borderClass}`
        } `}
      >
        <div className="flex flex-col min-h-25 py-2 justify-center">
          <div className="flex h-1/3">
            {masteryTrackApplicable && !isCompleted && (
              <div>
                <ResponsiveImage
                  alt="Puzzle Icon"
                  height={25}
                  srcKey={`curriculum/hats/black-hat-${topicId}.png`}
                  width={45}
                />
              </div>
            )}

            <div className={`mx-auto ${isCompleted ? 'text-white' : 'pr-8 text-gray-darker'}`}>
              <p className="text-xs ">{t('mappingQuiz.topicsIn')}</p>
            </div>
          </div>
          <div className={`${isCompleted ? 'text-white' : `${textColor}`}  h-2/3 -mt-1`}>
            <p className="text-md break-words">{description}</p>
          </div>
        </div>
        <span className="absolute top-1.5 right-2">
          <ArrowButton color={isCompleted ? 'text-white' : textColor} expanded={isExpanded} size={17} />
        </span>
      </div>
    </div>
  )
}
